/* models/widgets/main */ function _(require, module, exports) {
    var Widgets = require(452) /* ./index */;
    exports.Widgets = Widgets;
    var base_1 = require(0) /* ../../base */;
    base_1.register_models(Widgets);
}
